import { drawScheduleTypeIds } from './eventConstants';
import { EventTypes } from './events';
import EventTours from './EventTours';

export const buildUserParallelRequests = (
    { scheduleTypeId, eventTypeId, eventTours, isRecurringEvent, hasRecurringSeries, includeUnpublishedMatchSheet = false },
    eventId,
    dispatch,
    actions,
) => {
    const requests = [];

    if (scheduleTypeId === drawScheduleTypeIds.ORDER_OF_PLAY) {
        requests.push(dispatch(actions.getOrderOfPlaySchedule(eventId)));
    }
    if (scheduleTypeId === drawScheduleTypeIds.MATCH_SHEET) {
        requests.push(dispatch(actions.getMatchSheetV2(eventId, includeUnpublishedMatchSheet)));
    }
    if (eventTypeId === EventTypes.TEAM_LEAGUE) {
        requests.push(dispatch(actions.getEventTeamStandings(eventId)));
    }
    if (eventTours?.length && eventTours.find(t => t.id === EventTours.NationalPathwayTourTagId)) {
        requests.push(dispatch(actions.getEventRegions(eventId)));
    }

    requests.push(
        dispatch(actions.getDraws(eventId)),
        dispatch(actions.getEventInvites(eventId)),
        dispatch(actions.getRegistrations(eventId)),
        dispatch(actions.getEventLocations(eventId)),
        dispatch(actions.getEventOfficials(eventId)),
        dispatch(actions.getAllWeatherNotifications(eventId)),
        dispatch(actions.getCurrentMemberRegistration(eventId)),
    );

    if (isRecurringEvent || hasRecurringSeries) {
        requests.push(dispatch(actions.getUpcomingRecurringEvents(eventId)));
    }

    return requests;
};
